import { useState, useEffect } from "react";
import { loadDepartment } from "../services/departmentService";

const useDepartments = (editShiftAssignmentID) => {
    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [selectedDepartmentID, setSelectedDepartmentID] = useState(null);
    const [isDepartmentDataLoaded, setIsDepartmentDataLoaded] = useState(false);

    // Fetch department data
    const fetchDepartments = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadDepartment(para);
            if (data && data.length > 0) {
                setDepartments(data);

                // const initialDepartment = data.find((dept) => dept.id === selectedID) || data[0];
                const initialDepartment = data.find((dept) => dept.id === selectedID) ;
                if(initialDepartment?.length>0)
                {
                    setSelectedDepartment(initialDepartment);
                    setSelectedDepartmentID(initialDepartment.id);
                    setIsDepartmentDataLoaded(true);
                }
                
            }
            
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isDepartmentDataLoaded && editShiftAssignmentID === 0) {
            fetchDepartments();
        }
    }, [isDepartmentDataLoaded, editShiftAssignmentID]);

    // Function to load department based on selected ID
    const loadDepartmentByID = async (selectedID) => {
        await fetchDepartments(selectedID);
    };

    return {
        departments,
        selectedDepartment,
        selectedDepartmentID,
        setSelectedDepartment,
        setSelectedDepartmentID,
        loadDepartmentByID,
    };
};

export default useDepartments;
